// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"b7582b9e","258":"a72c5623","387":"ac6da3a4","542":"9adac170","686":"59acee4a","787":"335e9bdf"}[chunkId] + ".chunk.js";
};